"use client";

import { Link } from "@tanstack/react-router";

export default function LogoImage() {
  return (
    <Link to="/" aria-label="Roamdoc home">
      <img
        src="/roamdoc-logo.png"
        className="w-[100px] hover:cursor-pointer"
        alt="Roamdoc Logo"
        width={256}
        height={102}
      />
    </Link>
  );
}
